/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.ts` */
/* eslint-disable */
// noinspection JSUnusedGlobalSymbols, DuplicatedCode

import * as Types from '__generated__/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type LocationPlanningUnplannedActionsQueryVariables = Types.Exact<{
  search: Types.CargoActionSearch;
  pagination: Types.Pagination;
}>;


export type LocationPlanningUnplannedActionsQuery = {
  __typename?: 'Query',
  cargoActions: {
    __typename?: 'CargoActionPage',
    totalElements: number,
    content: Array<{
      __typename?: 'CargoAction',
      id: number,
      type: Types.CallType,
      weight?: number | null,
      volume?: number | null,
      start?: number | null,
      end?: number | null,
      cargo: {
        __typename?: 'Cargo',
        id: number,
        created?: number | null,
        charter?: {
          __typename?: 'SalesCharter',
          id: number,
          charterNumber: string,
          type: Types.CharterType,
          subtype: Types.CharterSubtype,
          debtor: {
            __typename?: 'Relation',
            id: number,
            name: string
          },
          cargos: Array<{
            __typename?: 'Cargo',
            id: number,
            actions: Array<{
              __typename?: 'CargoAction',
              id: number,
              start?: number | null,
              type: Types.CallType,
              weight?: number | null,
              volume?: number | null,
              location?: {
                __typename?: 'Location',
                id: number,
                type: Types.LocationType
              } | null
            }>,
            firstLoadingAction?: {
              __typename?: 'CargoAction',
              id: number,
              start?: number | null,
              location?: {
                __typename?: 'Location',
                id: number,
                description: string,
                type: Types.LocationType
              } | null
            } | null,
            lastDischargingAction?: {
              __typename?: 'CargoAction',
              id: number,
              end?: number | null,
              location?: {
                __typename?: 'Location',
                id: number,
                description: string,
                type: Types.LocationType
              } | null
            } | null
          }>,
          contract?: {
            __typename?: 'Contract',
            agreements: Array<{
              __typename?: 'AddressCommissionAgreement',
              type: Types.AgreementTypeEnum
            } | {
              __typename?: 'BlockFreightAgreement',
              type: Types.AgreementTypeEnum
            } | {
              __typename?: 'BunkerAdjustmentAgreement',
              type: Types.AgreementTypeEnum
            } | {
              __typename?: 'CleaningAgreement',
              type: Types.AgreementTypeEnum
            } | {
              __typename?: 'CommissionAgreement',
              type: Types.AgreementTypeEnum
            } | {
              __typename?: 'DailyAgreement',
              type: Types.AgreementTypeEnum
            } | {
              __typename?: 'DangerousGoodAgreement',
              type: Types.AgreementTypeEnum
            } | {
              __typename?: 'DeadfreightAgreement',
              type: Types.AgreementTypeEnum
            } | {
              __typename?: 'DemurrageAgreement',
              type: Types.AgreementTypeEnum
            } | {
              __typename?: 'DemurrageCalculationAgreement',
              type: Types.AgreementTypeEnum
            } | {
              __typename?: 'FeetAgreement',
              type: Types.AgreementTypeEnum
            } | {
              __typename?: 'FreightAgreement',
              type: Types.AgreementTypeEnum
            } | {
              __typename?: 'GasolineAgreement',
              type: Types.AgreementTypeEnum
            } | {
              __typename?: 'GasolinePriceAgreement',
              type: Types.AgreementTypeEnum
            } | {
              __typename?: 'HoseRentalAgreement',
              type: Types.AgreementTypeEnum
            } | {
              __typename?: 'HourlyAgreement',
              type: Types.AgreementTypeEnum
            } | {
              __typename?: 'LumpsumAgreement',
              type: Types.AgreementTypeEnum
            } | {
              __typename?: 'MultiCargoAdjustmentAgreement',
              type: Types.AgreementTypeEnum
            } | {
              __typename?: 'MultiOrderAdjustmentAgreement',
              type: Types.AgreementTypeEnum
            } | {
              __typename?: 'NitrogenPurgingAgreement',
              type: Types.AgreementTypeEnum
            } | {
              __typename?: 'OogAgreement',
              type: Types.AgreementTypeEnum
            } | {
              __typename?: 'PJKAgreement',
              type: Types.AgreementTypeEnum
            } | {
              __typename?: 'PostCalculationAgreement',
              type: Types.AgreementTypeEnum
            } | {
              __typename?: 'ReeferAgreement',
              type: Types.AgreementTypeEnum
            } | {
              __typename?: 'RentAgreement',
              type: Types.AgreementTypeEnum
            } | {
              __typename?: 'ReturnFreightDiscountAgreement',
              type: Types.AgreementTypeEnum
            } | {
              __typename?: 'ShipAgreement',
              type: Types.AgreementTypeEnum,
              ships?: Array<{
                __typename?: 'Ship',
                id: number,
                name: string
              }> | null
            } | {
              __typename?: 'SupplementaryHeatingAgreement',
              type: Types.AgreementTypeEnum
            } | {
              __typename?: 'TeuAgreement',
              type: Types.AgreementTypeEnum
            } | {
              __typename?: 'TextAgreement',
              type: Types.AgreementTypeEnum
            } | {
              __typename?: 'WaterLevelAgreement',
              type: Types.AgreementTypeEnum
            } | {
              __typename?: 'WaterwayAgreement',
              type: Types.AgreementTypeEnum
            } | {
              __typename?: 'WeightAgreement',
              type: Types.AgreementTypeEnum
            } | {
              __typename?: 'WeightRangeAgreement',
              type: Types.AgreementTypeEnum
            }>
          } | null
        } | null,
        deliveryCondition?: {
          __typename?: 'DeliveryCondition',
          id: number,
          description: string
        } | null,
        product?: {
          __typename?: 'Product',
          id: number,
          name: string
        } | null
      },
      processingTime?: {
        __typename?: 'PredictionWindow',
        durationInSeconds: number,
        warnings: Array<string>,
        window: {
          __typename?: 'TimeWindow',
          from?: number | null,
          to?: number | null
        },
        quay?: {
          __typename?: 'Quay',
          id: number
        } | null,
        locationAvailability?: {
          __typename?: 'LocationAvailability',
          id: number
        } | null
      } | null,
      location?: {
        __typename?: 'Location',
        id: number,
        description: string,
        type: Types.LocationType
      } | null,
      call?: {
        __typename?: 'Call',
        voyage: {
          __typename?: 'Voyage',
          ship: {
            __typename?: 'Ship',
            id: number,
            name: string
          }
        }
      } | null,
      firstCorrespondingLoadingAction?: {
        __typename?: 'CargoAction',
        id: number,
        start?: number | null,
        location?: {
          __typename?: 'Location',
          id: number,
          description: string,
          type: Types.LocationType
        } | null
      } | null,
      lastCorrespondingDischargingAction?: {
        __typename?: 'CargoAction',
        id: number,
        end?: number | null,
        location?: {
          __typename?: 'Location',
          id: number,
          description: string,
          type: Types.LocationType
        } | null
      } | null
    }>
  }
};

export type LocationPlanningPlannedActionsQueryVariables = Types.Exact<{
  search: Types.CargoActionSearch;
  pagination: Types.Pagination;
}>;


export type LocationPlanningPlannedActionsQuery = {
  __typename?: 'Query',
  cargoActions: {
    __typename?: 'CargoActionPage',
    totalElements: number,
    content: Array<{
      __typename?: 'CargoAction',
      id: number,
      type: Types.CallType,
      weight?: number | null,
      volume?: number | null,
      start?: number | null,
      end?: number | null,
      cargo: {
        __typename?: 'Cargo',
        id: number,
        created?: number | null,
        lastStatusChange?: {
          __typename?: 'StatusChange',
          status: {
            __typename?: 'Status',
            finishedStatus: boolean
          }
        } | null,
        charter?: {
          __typename?: 'SalesCharter',
          id: number,
          charterNumber: string,
          type: Types.CharterType
        } | null,
        product?: {
          __typename?: 'Product',
          id: number,
          name: string
        } | null
      },
      call?: {
        __typename?: 'Call',
        voyage: {
          __typename?: 'Voyage',
          id: number,
          voyageNumber: string,
          ship: {
            __typename?: 'Ship',
            id: number,
            name: string
          }
        }
      } | null,
      location?: {
        __typename?: 'Location',
        id: number,
        description: string,
        type: Types.LocationType
      } | null,
      firstCorrespondingLoadingAction?: {
        __typename?: 'CargoAction',
        id: number,
        start?: number | null,
        location?: {
          __typename?: 'Location',
          id: number,
          description: string,
          type: Types.LocationType
        } | null
      } | null,
      lastCorrespondingDischargingAction?: {
        __typename?: 'CargoAction',
        id: number,
        end?: number | null,
        location?: {
          __typename?: 'Location',
          id: number,
          description: string,
          type: Types.LocationType
        } | null
      } | null
    }>
  }
};

export type LocationPlanningSearchLocationsQueryVariables = Types.Exact<{
  locationSearch: Types.LocationSearchGql;
  pagination: Types.Pagination;
}>;


export type LocationPlanningSearchLocationsQuery = {
  __typename?: 'Query',
  searchLocations: {
    __typename?: 'LocationPage',
    totalElements: number,
    content: Array<{
      __typename?: 'Location',
      id: number,
      description: string,
      quays?: Array<{
        __typename?: 'Quay',
        id: number,
        name1?: string | null
      }> | null,
      openingHours?: {
        __typename?: 'OpeningHours',
        id: number,
        type?: Types.OpeningHoursType | null,
        mondayFrom?: number | null,
        mondayTo?: number | null,
        tuesdayFrom?: number | null,
        tuesdayTo?: number | null,
        wednesdayFrom?: number | null,
        wednesdayTo?: number | null,
        thursdayFrom?: number | null,
        thursdayTo?: number | null,
        fridayFrom?: number | null,
        fridayTo?: number | null,
        saturdayFrom?: number | null,
        saturdayTo?: number | null,
        sundayFrom?: number | null,
        sundayTo?: number | null
      } | null
    }>
  }
};

export type LocationPlanningPlanboardQueryVariables = Types.Exact<{
  window: Types.TimeWindowInput;
  locationIds: Array<Types.Scalars['Long']['input']>;
}>;


export type LocationPlanningPlanboardQuery = {
  __typename?: 'Query',
  locationAvailabilities: Array<{
    __typename?: 'LocationAvailability',
    id: number,
    type: Types.LocationAvailabilityType,
    fromDateTime: number,
    toDateTime: number,
    location: {
      __typename?: 'Location',
      id: number,
      description: string
    },
    bolderFrom: {
      __typename?: 'Bolder',
      quay: {
        __typename?: 'Quay',
        id: number
      }
    }
  }>,
  quayPlanningsForLocations: Array<{
    __typename?: 'QuayPlanning',
    id: number,
    start: number,
    end: number,
    cargoAction: {
      __typename?: 'CargoAction',
      id: number,
      weight?: number | null,
      location?: {
        __typename?: 'Location',
        id: number,
        description: string,
        type: Types.LocationType
      } | null,
      call?: {
        __typename?: 'Call',
        id: number,
        actualStatusCode?: number | null,
        pta?: number | null,
        eta?: number | null,
        ata?: number | null,
        ptd?: number | null,
        etd?: number | null,
        atd?: number | null,
        etso?: number | null,
        eteo?: number | null,
        atso?: number | null,
        ateo?: number | null,
        etfm?: number | null,
        etlm?: number | null,
        atfm?: number | null,
        atlm?: number | null,
        atn?: number | null,
        dtn?: number | null,
        systemAta?: number | null,
        systemAtd?: number | null,
        systemEta?: number | null,
        systemEtd?: number | null,
        location: {
          __typename?: 'Location',
          id: number,
          code?: string | null,
          displayCode?: string | null,
          description: string,
          type: Types.LocationType
        },
        voyage: {
          __typename?: 'Voyage',
          id: number,
          ship: {
            __typename?: 'Ship',
            id: number,
            name: string
          },
          creditor?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null
        },
        cargos: Array<{
          __typename?: 'CargoAction',
          id: number,
          type: Types.CallType,
          location?: {
            __typename?: 'Location',
            displayCode?: string | null,
            code?: string | null,
            id: number,
            description: string,
            type: Types.LocationType
          } | null,
          cargo: {
            __typename?: 'Cargo',
            id: number
          }
        }>,
        linkedChildCalls: Array<{
          __typename?: 'Call',
          id: number,
          weight?: number | null,
          voyage: {
            __typename?: 'Voyage',
            id: number,
            voyageNumber: string,
            ship: {
              __typename?: 'Ship',
              id: number,
              name: string
            }
          }
        }>
      } | null,
      cargo: {
        __typename?: 'Cargo',
        product?: {
          __typename?: 'Product',
          id: number,
          name: string
        } | null
      }
    },
    quay: {
      __typename?: 'Quay',
      id: number,
      name1?: string | null
    }
  }>
};


export const LocationPlanningUnplannedActionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"locationPlanningUnplannedActions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CargoActionSearch"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cargoActions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalElements"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationPlanningCargoAction"}},{"kind":"Field","name":{"kind":"Name","value":"cargo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShipLinkDialogSalesCharter"}},{"kind":"Field","name":{"kind":"Name","value":"debtor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactRelation"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryCondition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"processingTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"window"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"durationInSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"locationAvailability"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"warnings"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocationPlanningCargoAction"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CargoAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"charter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"call"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"voyage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstCorrespondingLoadingAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"start"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastCorrespondingDischargingAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompactLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShipLinkDialogSalesCharter"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SalesCharter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"subtype"}},{"kind":"Field","name":{"kind":"Name","value":"cargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstLoadingAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastDischargingAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CreateOrSelectCharterFormCargo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShipAgreement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreateOrSelectCharterFormCargo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Cargo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstLoadingAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastDischargingAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompactRelation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Relation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<LocationPlanningUnplannedActionsQuery, LocationPlanningUnplannedActionsQueryVariables>;
export const LocationPlanningPlannedActionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"locationPlanningPlannedActions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CargoActionSearch"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cargoActions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalElements"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationPlanningCargoAction"}},{"kind":"Field","name":{"kind":"Name","value":"cargo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"finishedStatus"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"call"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"voyage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voyageNumber"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocationPlanningCargoAction"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CargoAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"charter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"call"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"voyage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstCorrespondingLoadingAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"start"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastCorrespondingDischargingAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompactLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<LocationPlanningPlannedActionsQuery, LocationPlanningPlannedActionsQueryVariables>;
export const LocationPlanningSearchLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"locationPlanningSearchLocations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationSearch"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocationSearchGql"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchLocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locationSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationSearch"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalElements"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"quays"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name1"}}]}},{"kind":"Field","name":{"kind":"Name","value":"openingHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OpeningHours"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OpeningHours"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OpeningHours"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"mondayFrom"}},{"kind":"Field","name":{"kind":"Name","value":"mondayTo"}},{"kind":"Field","name":{"kind":"Name","value":"tuesdayFrom"}},{"kind":"Field","name":{"kind":"Name","value":"tuesdayTo"}},{"kind":"Field","name":{"kind":"Name","value":"wednesdayFrom"}},{"kind":"Field","name":{"kind":"Name","value":"wednesdayTo"}},{"kind":"Field","name":{"kind":"Name","value":"thursdayFrom"}},{"kind":"Field","name":{"kind":"Name","value":"thursdayTo"}},{"kind":"Field","name":{"kind":"Name","value":"fridayFrom"}},{"kind":"Field","name":{"kind":"Name","value":"fridayTo"}},{"kind":"Field","name":{"kind":"Name","value":"saturdayFrom"}},{"kind":"Field","name":{"kind":"Name","value":"saturdayTo"}},{"kind":"Field","name":{"kind":"Name","value":"sundayFrom"}},{"kind":"Field","name":{"kind":"Name","value":"sundayTo"}}]}}]} as unknown as DocumentNode<LocationPlanningSearchLocationsQuery, LocationPlanningSearchLocationsQueryVariables>;
export const LocationPlanningPlanboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"locationPlanningPlanboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"window"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TimeWindowInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationAvailabilities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"timeWindow"},"value":{"kind":"Variable","name":{"kind":"Name","value":"window"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationPlanningLocationAvailability"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quayPlanningsForLocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"timeWindow"},"value":{"kind":"Variable","name":{"kind":"Name","value":"window"}}},{"kind":"Argument","name":{"kind":"Name","value":"locationIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationPlanningPlanboardQuayPlanning"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompactLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocationPlanningLocationAvailability"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LocationAvailability"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"fromDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"toDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bolderFrom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocationPlanningPlanboardQuayPlanning"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuayPlanning"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"cargoAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"call"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallSideviewerCall"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"quay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name1"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallSideviewerCall"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Call"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actualStatusCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"displayCode"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"voyage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creditor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}},{"kind":"Field","name":{"kind":"Name","value":"displayCode"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkedChildCalls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"voyage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voyageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallTimes"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallTimes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Call"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pta"}},{"kind":"Field","name":{"kind":"Name","value":"eta"}},{"kind":"Field","name":{"kind":"Name","value":"ata"}},{"kind":"Field","name":{"kind":"Name","value":"ptd"}},{"kind":"Field","name":{"kind":"Name","value":"etd"}},{"kind":"Field","name":{"kind":"Name","value":"atd"}},{"kind":"Field","name":{"kind":"Name","value":"etso"}},{"kind":"Field","name":{"kind":"Name","value":"eteo"}},{"kind":"Field","name":{"kind":"Name","value":"atso"}},{"kind":"Field","name":{"kind":"Name","value":"ateo"}},{"kind":"Field","name":{"kind":"Name","value":"etfm"}},{"kind":"Field","name":{"kind":"Name","value":"etlm"}},{"kind":"Field","name":{"kind":"Name","value":"atfm"}},{"kind":"Field","name":{"kind":"Name","value":"atlm"}},{"kind":"Field","name":{"kind":"Name","value":"atn"}},{"kind":"Field","name":{"kind":"Name","value":"dtn"}},{"kind":"Field","name":{"kind":"Name","value":"systemAta"}},{"kind":"Field","name":{"kind":"Name","value":"systemAtd"}},{"kind":"Field","name":{"kind":"Name","value":"systemEta"}},{"kind":"Field","name":{"kind":"Name","value":"systemEtd"}}]}}]} as unknown as DocumentNode<LocationPlanningPlanboardQuery, LocationPlanningPlanboardQueryVariables>;